import React from 'react';
import './Carousel.scss';

export interface CarouselProps<T> {
    cards: (T | undefined)[];
    children: (arg: T | undefined, index?: number) => JSX.Element;
    noScrollMobile?: boolean;
    /**
     * defaults to 'center'
     * applies when no scroll mobile in effect
     */
    justifyContentValue?: string;
}

export const Carousel = <T,>(props: CarouselProps<T>): JSX.Element => {
    const { cards, children, justifyContentValue = 'center' } = props;
    return (
        <div
            className={`carousel ${
                props.noScrollMobile ? 'carousel__no-scroll' : ''
            }`}
            data-testid="carousel"
        >
            <div
                className="carousel-internal"
                style={{
                    justifyContent: props.noScrollMobile
                        ? justifyContentValue
                        : undefined,
                }}
            >
                {cards.map((cards, index) => children(cards, index))}
            </div>
        </div>
    );
};
